import { action } from '@ember/object';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import ContactsCache, {
  type ContactCustomPropertyInfo,
} from 'donor-elf-web/services/contacts-cache';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export interface PropertiesPropertyRouteModel {
  property: ContactCustomPropertyInfo;
}

export default class PropertiesPropertyRoute extends Route {
  @service declare contactsCache: ContactsCache;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare router: RouterService;

  model(params: { label: string }): PropertiesPropertyRouteModel | undefined {
    let property =
      this.contactsCache.customPropertiesByLowecaseLabel[
        params.label.toLowerCase()
      ];
    if (property == null) {
      if (
        params.label === this.contactsCache.groupsContactCustomPropertyInfo.l
      ) {
        property = this.contactsCache.groupsContactCustomPropertyInfo;
      }
    }
    if (property == null) {
      this.router.transitionTo('funds.fund.properties.index');
      return;
    }
    this.navbarSettings.title = `Edit ${property.l}`;

    return {
      property,
    };
  }

  @action
  refreshPropertyRouteModel() {
    this.refresh();
  }
}
